export * from "components/attachments/attachments-tags-mobile/attachments-tags-mobile"
